import React, { Component } from 'react';
import _ from 'lodash';
import Icon from 'react-fa';
import cx from 'classnames';

const MAX_STARS = 5;

class Item extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hoveredStars: -1
        };

        this.renderStars = this.renderStars.bind(this);
        this.starClasses = this.starClasses.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onHover(index, _e) {
        this.setState({
            hoveredStars: index
        });
    }

    onBlur(_e) {
        this.setState({
            hoveredStars: -1
        });
    }

    onClick(index, _e) {
        this.setState({
            hoveredStars: -1
        });

        this.props.onChange(this.props.id, index + 1);
    }

    starClasses() {
        return cx({
            stars: true,
            protherm: this.props.brand === 'protherm',
            vaillant: this.props.brand === 'vaillant'
        });
    }

    renderStars() {
        return _.times(MAX_STARS, (index) => {
            let name = null;

            if (this.state.hoveredStars > -1) {
                name = index < this.state.hoveredStars + 1 ? 'star' : 'star-o';
            } else {
                name = index < this.props.stars ? 'star' : 'star-o';
            }

            const iconClasses = cx({
                hovered: index < this.state.hoveredStars + 1
            });

            return (
                <Icon
                    className={iconClasses}
                    name={name}
                    key={index}
                    onMouseOver={this.onHover.bind(this, index)}
                    onMouseOut={this.onBlur}
                    onClick={this.onClick.bind(this, index)}
                />
            );
        });
    }

    render() {
        return (
            <div className="item">
                <h3>
                    <strong>{this.props.title}</strong><br />
                    {this.props.description}
                </h3>
                <div className={this.starClasses()}>
                    {this.renderStars()}
                </div>
            </div>
        );
    }
}

Item.propTypes = {
    title: React.PropTypes.string.isRequired,
    stars: React.PropTypes.number.isRequired,
    onChange: React.PropTypes.func.isRequired,
    id: React.PropTypes.number.isRequired,
    description: React.PropTypes.string.isRequired,
    brand: React.PropTypes.string.isRequired,
};
Item.defaultProps = {};
Item.contextTypes = {};

export default Item;



/** WEBPACK FOOTER **
 ** ./src/components/Item.js
 **/